// import classes from "./Header2.module.css";
// import { useNavigate } from 'react-router-dom';
// import { FaHouse, FaFutbol, FaTrophy, FaClock } from "react-icons/fa6";
// import { FaUser } from "react-icons/fa";

// /* ─── Bottom nav items ─── */
// const NAV_ITEMS = [
//   { icon: FaHouse,  label: "Home",        path: "/home",        id: 0 },
//   { icon: FaFutbol, label: "My Matches",  path: "/my-matches",  id: 1 },
//   { icon: FaClock,  label: "Live",        path: "/live",        id: 2 },
//   { icon: FaTrophy, label: "Leaderboard", path: "/winnings", id: 3 },
//   { icon: FaUser,   label: "Profile",     path: "/profile",     id: 4 },
// ];

// const Header2 = ({ active, hide }) => {
//   const navigate = useNavigate();

//   return (
//     <>

//       <header className={classes.topBar}>
//         <div className={classes.topBarInner}>

//           <div className={classes.logoWrap}>
//             <img src="/assets/images/logo.png" alt="logo" className={classes.logo_img} />
//           </div>

//         </div>


//         <div className={classes.redStrip} />
//       </header>


//       {!hide && (
//         <nav className={classes.bottomNav}>
//           <div className={classes.bottomNavInner}>
//             {NAV_ITEMS.map(({ icon: Icon, label, path, id }) => {
//               const isActive = active === id;
//               const isCenter = id === 2; 
//               return (
//                 <button
//                   key={id}
//                   type="button"
//                   className={`
//                     ${classes.navItem}
//                     ${isActive  ? classes.navItemActive  : ""}
//                     ${isCenter  ? classes.navItemCenter  : ""}
//                   `}
//                   onClick={() => navigate(path)}
//                   aria-label={label}
//                 >
//                   {isCenter ? (
//                     <span className={classes.centerOrb}>
//                       <Icon className={classes.centerIcon} />
//                     </span>
//                   ) : (
//                     <>
//                       <span className={classes.navIconWrap}>
//                         <Icon className={classes.navIcon} />
//                         {isActive && <span className={classes.activeGlow} />}
//                       </span>
//                       <span className={classes.navLabel}>{label}</span>
//                     </>
//                   )}
//                   {isCenter && (
//                     <span className={classes.centerLabel}>{label}</span>
//                   )}
//                 </button>
//               );
//             })}
//           </div>
//         </nav>
//       )}
//     </>
//   );
// };

// export default Header2;


import { useState } from "react";
import classes from "./Header2.module.css";
import { useNavigate } from "react-router-dom";
import {
  FaHouse, FaFutbol, FaTrophy, FaClock,
  FaBars, FaXmark, FaChevronRight,
  FaRightFromBracket,
  FaGift
} from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { removeUserDetails } from "../../store/slices/userSlice";
import { toast } from "react-toastify";
import { setLanguage } from "../../store/slices/languageSlice";

/* ─── Bottom nav items ─── */
const NAV_ITEMS = [
  { icon: FaHouse, label: "Home", path: "/home", id: 0 },
  { icon: FaFutbol, label: "My Matches", path: "/my-matches", id: 1 },
  { icon: FaClock, label: "Live", path: "/live", id: 2 },
  { icon: FaTrophy, label: "Winnings", path: "/winnings", id: 3 },
  { icon: FaUser, label: "Profile", path: "/profile", id: 4 },
];

/* ─── Drawer menu items ─── */
const DRAWER_ITEMS = [
  { icon: FaHouse, label: "Home", path: "/home", id: 0 },
  { icon: FaFutbol, label: "My Matches", path: "/my-matches", id: 1 },
  { icon: FaClock, label: "Live Scores", path: "/live", id: 2 },
  { icon: FaTrophy, label: "Winnings", path: "/winnings", id: 3 },
  { icon: FaGift, label: "Prizes", path: "/match-rewards-info", id: 5 },
  { icon: FaUser, label: "My Profile", path: "/profile", id: 4 },
];

const Header2 = ({ active, hide }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector(s => s?.persisted?.userSlice);

  const { selectedLanguage } = useSelector((s) => s.languageSlice);

  const handleNav = (path) => {
    setDrawerOpen(false);
    navigate(path);
  };

  const handleLogout = () => {
    dispatch(removeUserDetails());
    toast.success("Logged out successfully!");
    navigate("/");
  };

  return (
    <>
      {/* ══ TOP BAR ══ */}
      <header className={classes.topBar}>
        <div className={classes.topBarInner}>


          {/* Centre — logo */}
          <img
            src="/assets/images/logo.png"
            alt="Vodacom Football Predict"
            className={classes.logoImg}
          />

          <div className={classes.topBarInnerRight}>
            <select
              id="lang"
              name="lang"
              className={classes.dropdown}
              value={selectedLanguage}
              onChange={(event) => {
                dispatch(setLanguage(event.target.value));
                window.location.reload();
              }}
            >
              <option value="0">English</option>
              <option value="1">Swahili</option>
            </select>

            {/* Left — hamburger */}
            <button
              className={classes.menuBtn}
              onClick={() => setDrawerOpen(true)}
              aria-label="Open menu"
            >
              <span className={classes.hamburgerLine} />
              <span className={classes.hamburgerLine} />
              <span className={classes.hamburgerLine} />
            </button>

          </div>



        </div>
        {/* gradient underline strip */}
        <div className={classes.redStrip} />
      </header>

      {/* ══ OVERLAY ══ */}
      <div
        className={`${classes.overlay} ${drawerOpen ? classes.overlayVisible : ""}`}
        onClick={() => setDrawerOpen(false)}
      />

      {/* ══ DRAWER PANEL ══ */}
      <aside className={`${classes.drawer} ${drawerOpen ? classes.drawerOpen : ""}`}>

        {/* Drawer top */}
        <div className={classes.drawerHeader}>
          <div className={classes.drawerLogo}>

            <img
              src="/assets/images/logo.png"
              alt="Vodacom Football Predict"
              className={classes.logoImg}
            />

            {/* <div className={classes.drawerVodaCircle}>
              <svg viewBox="0 0 36 36" className={classes.drawerVodaSvg}>
                <path
                  fill="white"
                  d="M18 2C9.16 2 2 8.27 2 16c0 4.67 2.5 8.8 6.4 11.4L7 34l6.8-3.1C14.5 31.3 16.2 31.5 18 31.5 26.84 31.5 34 25.23 34 17.5 34 9.77 26.84 2 18 2z"
                />
              </svg>
            </div>
            <div className={classes.drawerLogoText}>
              <span className={classes.drawerWordmark}>vodacom</span>
              <span className={classes.drawerSub}>Football Predict</span>
            </div> */}
          </div>
          <button
            className={classes.closeBtn}
            onClick={() => setDrawerOpen(false)}
            aria-label="Close menu"
          >
            <FaXmark />
          </button>
        </div>

        {/* User card */}
        {/* {userDetails && (
          <div className={classes.drawerUser}>
            <div className={classes.drawerAvatar}>
              <FaUser className={classes.drawerAvatarIcon} />
            </div>
            <div className={classes.drawerUserInfo}>
              <span className={classes.drawerUserName}>
                {userDetails?.name || userDetails?.msisdn || "Player"}
              </span>
              <span className={classes.drawerUserSub}>Vodacom Subscriber</span>
            </div>
          </div>
        )} */}

        <div className={classes.drawerDivider} />

        {/* Nav links */}
        <nav className={classes.drawerNav}>
          <p className={classes.drawerSectionLabel}>Menu</p>
          {DRAWER_ITEMS.map(({ icon: Icon, label, path, id }) => {
            const isActive = active === id;
            return (
              <button
                key={id}
                type="button"
                className={`${classes.drawerItem} ${isActive ? classes.drawerItemActive : ""}`}
                onClick={() => handleNav(path)}
              >
                <span className={classes.drawerItemLeft}>
                  <span className={`${classes.drawerIconBubble} ${isActive ? classes.drawerIconBubbleActive : ""}`}>
                    <Icon className={classes.drawerItemIcon} />
                  </span>
                  <span className={classes.drawerItemLabel}>{label}</span>
                </span>
                <FaChevronRight className={classes.drawerItemArrow} />
              </button>
            );
          })}
        </nav>

        <div className={classes.drawerDivider} />

        {/* Logout */}
        <button
          type="button"
          className={classes.drawerLogout}
          onClick={handleLogout}
        >
          <span className={classes.drawerItemLeft}>
            <span className={classes.drawerIconBubble}>
              <FaRightFromBracket className={classes.drawerItemIcon} />
            </span>
            <span className={classes.drawerItemLabel}>Logout</span>
          </span>
        </button>

        {/* Footer */}
        <div className={classes.drawerFooter}>
          {/* <span>Powered by Vodacom</span> */}
          <span>© {new Date().getFullYear()} Door2Future Consultants Pvt Ltd</span>
        </div>

      </aside>

      {/* ══ BOTTOM NAV — pill ══ */}
      {!hide && (
        <nav className={classes.bottomNav}>
          <div className={classes.bottomPill}>
            {NAV_ITEMS.map(({ icon: Icon, label, path, id }) => {
              const isActive = active === id;
              const isCenter = id === 2;
              return (
                <button
                  key={id}
                  type="button"
                  className={`
                    ${classes.navItem}
                    ${isActive ? classes.navItemActive : ""}
                    ${isCenter ? classes.navItemCenter : ""}
                  `}
                  onClick={() => navigate(path)}
                  aria-label={label}
                >
                  {isCenter ? (
                    <span className={classes.centerOrb}>
                      <Icon className={classes.centerIcon} />
                    </span>
                  ) : (
                    <>
                      <span className={classes.navIconWrap}>
                        <Icon className={classes.navIcon} />
                        {isActive && <span className={classes.activeDot} />}
                      </span>
                      <span className={classes.navLabel}>{label}</span>
                    </>
                  )}
                  {isCenter && (
                    <span className={classes.centerLabel}>{label}</span>
                  )}
                </button>
              );
            })}
          </div>
        </nav>
      )}
    </>
  );
};

export default Header2;